import { render, staticRenderFns } from "./PageShellEM.vue?vue&type=template&id=5f453fb8"
import script from "./PageShellEM.vue?vue&type=script&lang=js"
export * from "./PageShellEM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports